module.exports = __webpack_public_path__ + "img/caminhao.0cb2d005.svg";